import { __assign, __read } from "tslib";
import { useMemo, useCallback } from 'react';
import { formatValue, getFromPath, getKeysDifference, transformToPercent, } from '@keen.io/charts-utils';
import { getLabel } from '../utils';
var useDistributedTooltip = function (_a) {
    var data = _a.data, keys = _a.keys, disabledKeys = _a.disabledKeys, selectors = _a.selectors, labelSelector = _a.labelSelector, tooltipSettings = _a.tooltipSettings, _b = _a.isTimePrecise, isTimePrecise = _b === void 0 ? false : _b, _c = _a.isPercentage, isPercentage = _c === void 0 ? false : _c, _d = _a.isStacked, isStacked = _d === void 0 ? false : _d;
    var _e = __read(selectors, 1), selector = _e[0].selector;
    var _f = __read(selector, 1), recordIndex = _f[0];
    var percentageData = isPercentage && isStacked
        ? transformToPercent(data, getKeysDifference(keys, disabledKeys))
        : [];
    var getTooltipLabel = useCallback(function (record, labelSelector, isGrouped) {
        var label = record[labelSelector];
        if (isTimePrecise) {
            return (tooltipSettings === null || tooltipSettings === void 0 ? void 0 : tooltipSettings.formatTime) ? tooltipSettings.formatTime(label)
                : label.toString();
        }
        return isGrouped ? record[labelSelector] : null;
    }, [isTimePrecise, tooltipSettings.formatTime]);
    var totalValue = useMemo(function () {
        if (isStacked && selectors.length > 1) {
            var total = getKeysDifference(keys, disabledKeys).reduce(function (acc, keyName) {
                var value = data[recordIndex][keyName];
                return acc + value;
            }, 0);
            return formatValue(total, tooltipSettings.formatValue);
        }
        return null;
    }, [selectors.length > 1, recordIndex, disabledKeys]);
    var percentValue = isPercentage
        ? selectors.reduce(function (acc, _a) {
            var selector = _a.selector;
            return (acc + parseFloat(getFromPath(percentageData, selector).toFixed(2)));
        }, 0)
        : null;
    var items = selectors.map(function (_a) {
        var color = _a.color, selector = _a.selector;
        return {
            color: color,
            data: __assign({ label: "" + selector[1] }, getLabel({
                data: data,
                selector: selector,
                percentageData: percentageData,
                isPercentage: isPercentage,
                formatValue: tooltipSettings.formatValue,
            })),
        };
    });
    return {
        label: getTooltipLabel(data[recordIndex], labelSelector, data.length > 1),
        percentValue: percentValue,
        totalValue: totalValue,
        items: items,
    };
};
export default useDistributedTooltip;
